import React from "react";
import { Helmet } from "react-helmet";
import { buildWantAdSeo, buildWantAdJsonLd } from "../helpers/seo";
import { useCurrentWebsite } from "@/hooks/useCurrentWebsite";
import { loggedInUser } from "@/helpers/common";

const SeoHeadTags = ({ adDetails }) => {
  const { isGitchaDefaultWebsite } = useCurrentWebsite();
  const isPublicVisitor = isGitchaDefaultWebsite === true && !loggedInUser();
  const origin = typeof window !== "undefined" ? window.location.origin : "";
  const pathname = typeof window !== "undefined" ? window.location.pathname : "";
  const seo = buildWantAdSeo(adDetails, { origin, pathname });
  const jsonLd = buildWantAdJsonLd(adDetails, { origin, pathname, isPublicVisitor });

  return (
    <Helmet>
      <title>{seo.title}</title>
      <meta name="description" content={seo.description} />
      {seo.robots ? <meta name="robots" content={seo.robots} /> : null}
      {seo.canonical ? <link rel="canonical" href={seo.canonical} /> : null}
      <meta property="og:type" content="website" />
      <meta property="og:title" content={seo.title} />
      <meta property="og:description" content={seo.description} />
      {seo.canonical ? (
        <meta property="og:url" content={seo.canonical} />
      ) : null}
      {seo.ogImage ? <meta property="og:image" content={seo.ogImage} /> : null}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={seo.title} />
      <meta name="twitter:description" content={seo.description} />
      {jsonLd ? (
        <script type="application/ld+json">
          {JSON.stringify(jsonLd).replace(/</g, "\\u003c")}
        </script>
      ) : null}
    </Helmet>
  );
};

class SeoHead extends React.Component {
  constructor(props) {
    super(props);
    this.state = { failed: false };
  }

  static getDerivedStateFromError() {
    return { failed: true };
  }

  render() {
    if (this.state.failed) {
      return null;
    }
    return <SeoHeadTags adDetails={this.props.adDetails} />;
  }
}

export default SeoHead;
